export class DossierGet {
  static readonly type = '[Dossier] Get';
}
